export default function(parentModule: string): string {
    const moduleName = `${parentModule}.pipes`;
    return angular.module(moduleName, [])
                  .name;
}
